@if (helpText !== '') {
  <small class="help-text">{{helpText}}</small>
}